import {Component, createRef, RefObject} from 'react';
import {Container, Nav, Navbar, NavDropdown, OverlayTrigger, Tooltip} from "react-bootstrap";
import {
  BoxArrowRight,
  LockFill,
  Envelope,
  Gear,
  HouseFill,
  PersonFill,
  QuestionCircleFill
} from 'react-bootstrap-icons';

import AppContext from '../../AppContext';

import 'bootstrap-icons/font/bootstrap-icons.css';
import "./AppBar.css";

import logo from '../../../images/logo.gif';

interface AppBarProps {
  isDropDownOpen: boolean;
}

class AppBar extends Component<{}, AppBarProps> {

  static contextType = AppContext; // this line ensure the context variable below being populated
  context!: React.ContextType<typeof AppContext>;

  dropdownRef: RefObject<HTMLDivElement>;

  constructor(props: {}) {
    super(props);
    this.state = {
      isDropDownOpen: false,
    }
    this.dropdownRef = createRef();
  }

  renderTooltip = (props: any) => (
      <Tooltip id="app-dropdown-tooltip" {...props}>
        {this.context?.userProfile?.userName}
      </Tooltip>
  );

  handleToggle = () => {
    // setting the state will trigger the re-render of the AppBar.
    this.setState(prevState => ({isDropDownOpen: !prevState.isDropDownOpen}));
  };

  render() {
    const userProfile = this.context?.userProfile;

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container fluid>
            <Navbar.Brand href="/ams" className="appbar-text"><img src={logo} alt="Logo"
                                                                   className="company-logo"/>AMS</Navbar.Brand>
            {/*Added this check so we don't show the profile and logout page when the user is not logged in*/}
            {!userProfile ? (
                <></>
            ) : (
                <>
                  <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto" ref={this.dropdownRef}>
                      <NavDropdown title={
                        <OverlayTrigger placement="bottom" delay={{show: 250, hide: 300}} overlay={this.renderTooltip}>
                          <PersonFill color="white" size={22}/>
                        </OverlayTrigger>} id="basic-nav-dropdown" onClick={this.handleToggle} align="end">
                        <NavDropdown.Item className="appbar-nav-item"
                                          disabled>{userProfile?.userName}</NavDropdown.Item>
                        <NavDropdown.Item href="/ams/index.jsp" className="appbar-nav-item">
                          <HouseFill color="grey" className="appbar-nav-icon"/>Home
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/ams/msgs/view" className="appbar-nav-item">
                          <Envelope color="grey" className="appbar-nav-icon"/>Messages
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/ams/userPrefs" className="appbar-nav-item">
                          <Gear color="grey" className="appbar-nav-icon"/>Preferences
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/ams/user/changePassword" className="appbar-nav-item">
                          <LockFill color="grey" className="appbar-nav-icon"/>Change Password
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/ams/about.jsp" className="appbar-nav-item">
                          <QuestionCircleFill color="grey" className="appbar-nav-icon"/>About
                        </NavDropdown.Item>
                      </NavDropdown>
                      <div></div>
                      <Nav.Link href="/ams/index.jsp?sf_logout=true" className="appbar-text">
                        <BoxArrowRight color="white" size={22} className="logout-icon"/>
                        Logout
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </>
            )}
          </Container>
        </Navbar>);
  };
}

export default AppBar;

